import { getMessages } from '../../../../../../store/constants';

export const TEMPLATE_BOARD_ID_SESSIONSTORAGE = 'TEMPLATE_BOARD_ID_SESSIONSTORAGE';
export const FEATURE_POLL_FIRST_VISIT_COOKIE_NAME = 'showTemplatePoll';
export const TEMPLATE_POLL_MAX_START_FOR_REVIEW = 4;
export const TEMPLATE_POLL_TITLE = getMessages().getText('template-poll.title');
export const TEMPLATE_POLL_REVIEW_TITLE = getMessages().getText('template-poll.review.title');
